/* eslint-disable */

import React, { createRef } from "react";
import Modal from "react-bootstrap/Modal";
import Dropzone from "react-dropzone";
import APIClient from "../client";
import { Button, OverlayTrigger, Popover, Spinner } from "react-bootstrap";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";

class DatasetDropZoneModal extends React.Component {
  state = {
    files: [],
  };

  acceptedExtensions = [".csv", ".zip", ".tiff", ".tif"];

  getAcceptedExtensions() {
    const extentions = [];
    this.acceptedExtensions.forEach((ext) => {
      extentions.push(ext);
      extentions.push(ext.toUpperCase());
      extentions.push(ext.charAt(0).toUpperCase() + ext.slice(1));
    });
    return extentions;
  }

  constructor(props) {
    super(props);
    this.dropzoneRef = createRef();
  }

  openDropzoneDialog = () => {
    if (this.dropzoneRef.current) {
      this.dropzoneRef.current.open();
    }
  };

  handleFileUpload = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles && rejectedFiles.length > 0) {
      cropr.notify(
        "error",
        gettext(
          interpolate(
            gettext(
              "Only the following file types are accepted: %s, and maximum file size is 500MB"
            ),
            [this.acceptedExtensions.join(", ")]
          )
        )
      );
    }
    this.props.handleShow();
    acceptedFiles.forEach((f) => {
      const files = this.state.files.slice();
      let newUpload = { status: "processing", file: f };
      files.push(newUpload);
      this.setState({ files: files });
      let form = new FormData();
      form.append("file", f);
      APIClient.post(
        "/api/data/users/proces_uploaded_file/",
        { formData: form },
        cropr.cloudfarm_oauth_token
      )
        .then((response) => {
          let results = {},
            reload = false;
          response.forEach((fileupload_response) => {
            if (!results[fileupload_response.code]) {
              results[fileupload_response.code] = { nr: 0, details: "" };
            }
            let result = results[fileupload_response.code];
            if (fileupload_response.success) {
              if (fileupload_response.uuids.length) {
                reload = true;
                result.nr += fileupload_response.uuids.length;
              }
            } else {
              result.nr += 1;
            }
            result.details += fileupload_response.message + "\n";
          });

          // If some files successful processed, hide warnings, errors
          if (results["CF00"]) {
            results = { CF00: results["CF00"] };
          }
          const files = this.state.files.slice();
          newUpload["status"] = "complete";
          newUpload["results"] = results;
          this.setState({ files: files });
          if (reload) {
            this.props.handleReload();
          }
        })
        .catch((response) => {
          const files = this.state.files.slice();
          newUpload["status"] = "failed";
          newUpload["results"] = {
            error_upload: {
              details: gettext("Something went wrong while uploading this file"),
              nr: 0,
            },
          };
          this.setState({ files: files });
        });
    });
  };

  handleRemove(e, index) {
    e.preventDefault();
    e.stopPropagation();
    const files = this.state.files.slice();
    files.splice(index, 1);
    this.setState({ files: files });
  }

  render() {
    return (
      <Dropzone
        ref={this.dropzoneRef}
        onDrop={this.handleFileUpload}
        onFileDialogCancel={this.handleHide}
        maxSize={2000 * 1024 * 1024}
        accept={this.getAcceptedExtensions()}
      >
        {({ getRootProps, getInputProps }) => (
          <>
            <a href="#" className="dropdown-item" onClick={this.openDropzoneDialog}>
              <input {...getInputProps()} />
              {gettext("File Upload")}
            </a>
            <Modal show={this.props.showModal} onHide={this.props.handleHide} scrollable={true}>
              <Modal.Header closeButton>
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  className="mw-50"
                  overlay={helpPopover}
                >
                  <Button variant="info" className="ml-2">
                    {gettext("Help")}
                  </Button>
                </OverlayTrigger>
              </Modal.Header>
              <Modal.Body>
                <div {...getRootProps()} className="border p-2 minh-160px">
                  <div className="text-center text-muted mb-4">
                    <h5>{gettext("Drag 'n' drop files here, or click to select files")}</h5>
                  </div>
                  {this.state.files.map((f, i) => (
                    <div key={f.file.name + i}>
                      <div className="clearfix">
                        <span>{f.file.name}</span>
                        {f.results ? (
                          Object.keys(f.results).map((code) => (
                            <span
                              key={code}
                              className={"ml-1 badge badge-" + CF_MESSAGES[code].badge}
                              title={f.results[code].details}
                            >
                              {(code === "CF00" ? f.results[code].nr + " " : "") +
                                CF_MESSAGES[code].msg}
                            </span>
                          ))
                        ) : (
                          <span className="ml-1">
                            <Spinner animation="border" size="sm" />
                          </span>
                        )}
                        <div className="float-right">
                          <a className="btn" onClick={(e) => this.handleRemove(e, i)}>
                            <i className="fas fa-trash-alt" />
                          </a>
                        </div>
                      </div>
                      <hr />
                    </div>
                  ))}
                </div>
              </Modal.Body>
            </Modal>
          </>
        )}
      </Dropzone>
    );
  }
}

const helpTexts = [
  {
    header: gettext("Files types"),
    text:
      gettext(
        "The following file types are accepted: ISOBUS XML, CSV, SHP, TIFF. We continuously work on improving support for file types. "
      ) +
      " " +
      gettext("If you have file types that you think should be supported, please contact us."),
  },
  {
    header: "ISOBUS XML",
    text:
      gettext(
        "These files can be generated by tractors of various brands that comply with the ISO-11783 standard. "
      ) +
      " " +
      gettext(
        "This should be a zip file containing a file called 'TASKDATA.XML' and one or more '.BIN' files."
      ),
  },
  {
    header: "CSV",
    text:
      gettext(
        "These are plain text files that use either a comma ',', ';' or a tab as separator. The extention should be '.csv'. "
      ) +
      " " +
      gettext(
        "As geometric information is required for cloudfarm datasets, columns with coordinates should be included. They should be named 'lat' or 'latitude' and 'lon' or 'longitude'. "
      ) +
      " " +
      gettext("The coordinates should use the EPSG 4326 standard (degrees). ") +
      " " +
      gettext("Furthermore  a column with a timestamp can optionally be included. ") +
      " " +
      gettext(
        "They should be named 'date (yymmdd)' and 'time (hh:mm:ss)' or 'Timestamp' (i.e. 2018-05-18T11:47:22.234) or 'year', 'month', 'day', 'hr', 'min', 'sec'."
      ),
  },
  {
    header: "SHP",
    text: gettext(
      "Only shape files containing point data are supported currently. A shape file should be uploaded in a zip file containing all required files (*.shp, *.dbf, *.shx, *.prj)."
    ),
  },
  {
    header: "TIFF",
    text:
      gettext("Only specific TIFF files are currently supported. ") +
      " " +
      gettext(
        "The tiff file should contain 1 band (except rgb) and the name should contain one of the following strings: 'rgb', 'mosaic', 'savi', 'lai', 'ndre', 'dsm', 'ci_red', 'temperature', 'thermal', 'wdvi', 'ndvi'."
      ),
  },
  {
    header: gettext("Measurements"),
    text:
      gettext(
        "All columns that contain numeric values and which are not geometry or timestamp, are considered measurements. The name is derived from the column header. "
      ) +
      " " +
      gettext(
        "Behind the column name the measurement unit can be included in brackets. I.e. 'Width (m)' will be interpreted as measurement 'Width', with unit 'm'. "
      ) +
      " " +
      gettext(
        "If the column is name 'workwidth', its value will be use to draw the worked area path."
      ),
  },
  {
    header: gettext("Recording date"),
    text:
      gettext(
        "The recording date of the dataset is derived from the measurements if a timestamp is available. Alternatively the recording date can be derived from the file name. "
      ) +
      " " +
      gettext(
        "For a file called '20160616-071854_test_filename.csv' the recording date will be set at june 16, 2016, 7:18. The time is optional. "
      ) +
      " " +
      gettext(
        "The date (and time) can be either at the start or end of the file name. Also hyphens are allowed in the date (i.e. '2016-06-16_test_filename.csv')"
      ),
  },
  {
    header: gettext("Drag and drop"),
    text: gettext(
      "Files can be uploaded by dragging them on the cloudfarm window. This popup will appear automatically. Multiple files can be dragged at once."
    ),
  },
  {
    header: gettext("Multiple files"),
    text:
      gettext("Multiple files can be uploaded at once by combining them in a zip file. ") +
      " " +
      gettext(
        "The zip file will be extracted recursively (a zip can contain other zip files) and all suitable files will be processed."
      ),
  },
];

const helpPopover = (
  <Popover className="mw-480px h-75">
    <h3 className="popover-header">{gettext("Help with uploading files")}</h3>
    <div className="popover-body overflow-auto h-90">
      <table className="table table-borderless p-0 w-100">
        <tbody>
          {helpTexts.map((h, i) => (
            <tr key={i}>
              <th scope="row">{h.header}</th>
              <td>{h.text}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Popover>
);

const CF_MESSAGES = {
  CF00: { msg: gettext("Data set(s) added"), badge: "success" },
  CF01: { msg: gettext("Error while processing"), badge: "warning" },
  CF02: { msg: gettext("Already stored"), badge: "info" },
  CF03: { msg: gettext("Missing files"), badge: "warning" },
  CF04: { msg: gettext("Unknown file format"), badge: "info" },
  CF05: { msg: gettext("Error"), badge: "danger" },
  error_upload: { msg: gettext("Error uploading file"), badge: "danger" },
};

export default DatasetDropZoneModal;
